import { useLayoutEffect, useRef } from 'react';

/**
 * 1) Принимает объект с данными которые нужно отправить.
 * 2) Создает невидимую форму и отправляет.
 */
export function FormSender({
  data,
  action
}: {
  data: Record<string, string>;
  action: string | undefined;
}) {
  const invisibleFormRef = useRef<HTMLFormElement>(null);

  useLayoutEffect(() => {
    if (invisibleFormRef.current) {
      invisibleFormRef.current.submit();
    }
  }, []);

  return (
    <form className="hidden" method="POST" action={action} ref={invisibleFormRef}>
      {Object.entries(data).map(([key, value]) => (
        <input type="text" name={key} value={value} key={key} />
      ))}
    </form>
  );
}
